import DashboardLayout from "components/layouts/dashboard-layout";
import Default from "./components/default";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { SplitSheet } from "types/response-type";
import PatternImg from "images/png/rated-playlist-background-pattern.png";
import SplitPage from "./components/SplitPage";
import api from "services/axiosInstance";
import { useSearchParams } from "react-router-dom";
import Toast from "components/toast";
const DashboardSplits = () => {
  const [split, setSplit] = useState<SplitSheet>();
  const [activeTrackName, setActiveTrackName] = useState("");
  const [activeTrackId, setActiveTrackId] = useState("");
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const trackId = searchParams.get("id");
  const trackName = searchParams.get("name");

  const GetSplitSheet = async () => {
    if (!trackId || loading) return;

    try {
      setLoading(true);
      const { data } = await api.get(`/split-sheets/song/${trackId}`);
      const splitsheetData = data.data;

      setActiveTrackId(trackId);
      setActiveTrackName(trackName || "");
      setSplit(splitsheetData.currentSplitSheet);
    } catch (error) {
      Toast({ error });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (trackId) {
      GetSplitSheet();
    }
  }, [trackId]);
  return (
    <DashboardLayout>
      <Main>
        {!split && <BgHeader src={PatternImg} alt="bg-pattern" />}
        {!split && (
          <Default
            setSplit={(split) => setSplit(split)}
            setTrackName={(name) => {
              setActiveTrackName(name);
            }}
            setTrackId={(id) => {
              setActiveTrackId(id);
            }}
          />
        )}
        {split && (
          <SplitPage
            splitSheet={split}
            trackName={activeTrackName}
            trackId={activeTrackId}
            onSuccess={() => {
              setSplit(undefined);
            }}
          />
        )}
      </Main>
    </DashboardLayout>
  );
};

export default DashboardSplits;

const Main = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
`;

const BgHeader = styled.img`
  position: absolute;
  width: 100%;
  top: 5%;
  height: 100%;
  @media only screen and (max-width: 769px) {
    height: 100%;
    width: 350%;
    top: 0%;
    left: -10%;
  }
`;
